import React from 'react'
import Thumbnails from './Thumbnails'
import { useGetContentQuery } from '../../redux/services/contentApi';

const ThumbnailsFiles = ({ style, length, thumbnailsUrl, thumbnailSizes }) => {
    const { data, isFetching } = useGetContentQuery(thumbnailsUrl)

    return (
        <Thumbnails style={style} length={length} data={data} isFetching={isFetching} thumbnailSizes={thumbnailSizes} />
    )
}

export default ThumbnailsFiles
